import { useState, useEffect } from 'react';

export const useLocationPopup = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    // Check if user has already selected a location
    const hasSelectedLocation = localStorage.getItem('schoolola_location_selected');
    
    if (!hasSelectedLocation) {
      // Show popup after a brief delay to ensure page is loaded
      const timer = setTimeout(() => {
        setIsPopupOpen(true);
      }, 500);

      return () => clearTimeout(timer);
    }
  }, []);

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  return {
    isPopupOpen,
    closePopup,
    openPopup
  };
};